var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ei-num"},[_c('span',{class:{before:_vm.isBefore,after:_vm.isAfter},attrs:{"data-before":_vm.countBefore,"data-after":_vm.countAfter}},[_vm._v(_vm._s(_vm.count))])])}
var staticRenderFns = []

export { render, staticRenderFns }